import { useEffect, useState } from "react";
import { BellRing, TrendingDown, TrendingUp, Ban } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import api from "@/lib/api";

const ROWS = [
  { key: "price_drop", label: "Price drops", desc: "When a watchlisted item's price falls", Icon: TrendingDown, color: "text-rose-500" },
  { key: "price_increase", label: "Price increases", desc: "When a watchlisted item's price rises", Icon: TrendingUp, color: "text-emerald-500" },
  { key: "off_market", label: "Off-market", desc: "When a watchlisted item is no longer available", Icon: Ban, color: "text-muted-foreground" },
];

export default function AlertPreferences() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => { api.get("/alert-preferences").then((r) => setPrefs(r.data)).catch(() => {}); }, []);

  const toggle = async (key, value) => {
    const next = { ...prefs, [key]: value };
    setPrefs(next);
    try { await api.put("/alert-preferences", next); toast.success("Alert preferences saved"); }
    catch { toast.error("Could not save"); setPrefs(prefs); }
  };

  if (!prefs) return null;
  return (
    <div className="bg-surface border border-border rounded-2xl p-6 mb-10 max-w-lg" data-testid="alert-preferences">
      <div className="flex items-center gap-2 mb-1"><BellRing className="w-5 h-5 text-accent" /><h3 className="font-display text-xl font-medium">Watchlist alert preferences</h3></div>
      <p className="text-sm text-muted-foreground mb-5">Choose which alerts you get for the homes and vehicles you're watching.</p>
      <div className="space-y-4">
        {ROWS.map(({ key, label, desc, Icon, color }) => (
          <div key={key} className="flex items-center justify-between gap-4" data-testid={`alert-pref-row-${key}`}>
            <div className="flex items-start gap-3">
              <Icon className={`w-4 h-4 mt-0.5 ${color}`} />
              <div><div className="text-sm font-medium">{label}</div><div className="text-xs text-muted-foreground">{desc}</div></div>
            </div>
            <Switch checked={!!prefs[key]} onCheckedChange={(v) => toggle(key, v)} data-testid={`alert-pref-toggle-${key}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
